/*global window, AffiliateDashboard, document*/

const loadApp = () => {
  // eslint-disable-next-line no-undef
  jQuery(document).ready(function ($) {
    const SFTranslator = {
      applyTranslation : (language, fileLocationPath = null)=>{
        if (fileLocationPath == null) {
          fileLocationPath = fileLocationPath+'translation.'+language+'.json'
        }
        $.getJSON(fileLocationPath, function(translationData) {
          if (!translationData) {
            return;
          }
          for (const item in translationData) {
            const $labelKey = $('[data-SF_translation_key="'+item+'"]')
            $labelKey.html(translationData[item])
            if ($labelKey.attr('for')) {
              $('#'+$labelKey.attr('for')).attr('placeholder', translationData[item])
            }
          }
        });
      }
    }
    
    const Dashboard = {
      onload: () => {
        const SFAffiliate = window.SFShopifyApp.customer.SFAffiliate
        if (!SFAffiliate) {
          $('#affiliate-dashboard').html('<span data-SF_translation_key="activeAffiliateMessage">You must be an active '+window.SFShopifyApp.affiliate_term+' to access your '+window.SFShopifyApp.affiliate_term+ ' Dashboard</span>')
          if (window.SFShopifyApp.translate_to) {
            SFTranslator.applyTranslation(window.SFShopifyApp.translate_to, window.SFShopifyApp.translate_file_location)
          }
          return
        }
        Dashboard.loadLibraries()
        Dashboard.loadCss()
        Dashboard.loadHtml()
        Dashboard.loadDashboardAssets()
      },
      loadHtml: () => {
        let markup = ''
        markup += Dashboard.affiliateInfoHtml()
        markup += Dashboard.dashboardHtml()
        markup += Dashboard.affiliateOrderHtml()
        markup += Dashboard.downLineHtml()
        markup += Dashboard.loaderHtml()
        $('#affiliate-dashboard').html(markup)
      },
      affiliateInfoHtml: () => {
        const SFDiscountCode = window.SFShopifyApp.customer.SFDiscountCode
        const SFPaypalEmail = window.SFShopifyApp.customer.SFPaypalEmail
        if (!SFDiscountCode) {
          return ''
        }
        let toReturn = `
          <div>
            <div class="affiliate-info">
              <h2 class="myUniqueCodeHeading"><span data-SF_translation_key="myUniqueCodeAndURL">My Unique Code and URL</span></h2>
              <div class="code"><span data-SF_translation_key="yourAffiliateCode">Your ${window.SFShopifyApp.affiliate_term} Code</span>: <span>${SFDiscountCode}</span></div>
              <div class="input-group mb-2 copy-input-group">
                <div class="input-group-prepend">
                  <button type="button" id="btn-copy-username-referral-url" class="btn-input-group-copy-value input-group-text" data-copy_element_id="SFfiliate_username_referral_url">Copy</button>
                </div>
                <input type="text" class="form-control" id="SFfiliate_username_referral_url" readonly="" value="${window.SFShopifyApp.shop_domain}discount/${SFDiscountCode}">
              </div>
              `
        if (window.SFShopifyApp.settings.enable_option_to_view_edit_paypal_information) {
          toReturn += `<div>Your Paypal Email: <a href="javascript:void(0)">${SFPaypalEmail} <img height="15" width="15" src="${window.SFShopifyApp.proxy_url}/edit_icon.png" id="edit_affiliate_paypal" data-paypal_email="${SFPaypalEmail}"/></a></div>`
        }
        toReturn += `
              <div class="affiliate_qr_code_container">
                <a href="javascript:void(0)" rel="noopener noreferrer" id="view_my_affiliate_qr_code" data-open="false"><span data-SF_translation_key="viewMyAffiliateQRCode">View My ${window.SFShopifyApp.affiliate_term} QRCode</span></a>
                <canvas id="affiliate_qr_code" style="display: none;"></canvas>
              </div>
            </div>
          </div>`
        return toReturn
      },
      dashboardHtml: () => {
        const SFAffiliate = window.SFShopifyApp.customer.SFAffiliate
        const compensation_plan_url = window.SFShopifyApp.settings.compensation_plan_url
        // const SFpersonaldiscountcode = window.SFShopifyApp.customer.SFpersonaldiscountcode
        let htmlToReturn = `
          <div id="affiliate-dashboard-main" affiliate-id="${SFAffiliate}">
            <div class="date-wrapper form-group">
              <div class='input-group date' id='affiliate-dashboard-date-picker'>
                <input type='text' class="form-control" id="datepicker"/>
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-calendar"></span>
                </span>
              </div>`
        if (compensation_plan_url && compensation_plan_url != '') {
          htmlToReturn += `
            <div class="compansion-plan">
              <a href="${compensation_plan_url}" target="_blank">Open a PDF of the Compensation Plan</a>
            </div>`
        }
        htmlToReturn += `
            </div>
            <div style="display:block !important">`
        if (window.SFShopifyApp.customer.SFpersonaldiscountcode) {
          htmlToReturn += ` <p style="font-weight:600; margin-bottom:2px;">Customer Personal Code: ${window.SFShopifyApp.customer.SFpersonaldiscountcode}</p>`
        }
        if (window.SFShopifyApp.customer.SFpaypalemail) {
          htmlToReturn += ` <p style="font-weight:600; margin-bottom:2px;">Paypal Email: ${window.SFShopifyApp.customer.SFpaypalemail}</p>`
        }
        htmlToReturn += `
            </div>
            <div id="SFfiliate-dashboard-container">
              <div id="affiliate-performance-dashboard-chart" style="width: 450px; height: 500px;"></div>
              <div class="dashboard-chart-wrapper">
                <div>
                  <h2 class="retail-performance-title" data-SF_translation_key="retailPerformance">Retail Performance</h2>
                  <div class="dashboard-retail-wrapper">
                  </div>
                </div>
                <div>
                  <h2 class="comp-performance-title" data-SF_translation_key="compPerformance">Comp Performance</h2>
                  <div class="dashboard-comp-wrapper">
                  </div>
                </div>
                <h2 class="dashboard-share-title">Share Performance</h2>
                <div class="dashboard-share-wrapper">
                </div>
                <div class="dashboard-bonus-wrapper">
                  <h2 class="dashboard-bonus-title">Bonus Performance</h2>
                </div>
                <div>
                  <h2 class="earning-title"><span data-SF_translation_key="earnings">Earnings</span></h2>
                  <div class="dashboard-earnings-wrapper">
                  </div>
                </div>
              </div>
            </div>`
        return htmlToReturn
      },
      downLineHtml: () => {
        return `
        <div class="affiliate-downline-snippet">
          <div class="search_order">
            <h2><span data-SF_translation_key="referredAffiliateOrders">Referred ${window.SFShopifyApp.affiliate_term} Orders</span> (<span data-SF_translation_key="level">Level</span> 1)</h2>
            <div class="search-box">
              <label for="downline-searchBox" data-SF_translation_key="downlineSearchBox" style="display:none">Search ${window.SFShopifyApp.affiliate_term}</label>
              <input type="text" id="downline-searchBox" placeholder="Search ${window.SFShopifyApp.affiliate_term}" class="search-input" />
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20px" height="20px">
                  <path
                    d="M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z" />
                </svg>
              </div>
            </div>
          </div>
          <div id="downline-dataTableContainer"></div>
          <div id="downline-pagination"></div>
        </div>
        `
      },
      affiliateOrderHtml: () => {
        return `
        <div class="affiliate-order-snippet">
          <div class="search_order">
            <h2 data-SF_translation_key="myPersonalAndCustomerOrders">My Personal and Customer Orders</h2>
            <div class="search-box">
              <label for="searchBox" data-SF_translation_key="searchBox" style="display:none">Search Order</label>
              <input type="text" id="searchBox" placeholder="Search Order" class="search-input" />
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20px" height="20px">
                  <path
                    d="M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z" />
                </svg>
              </div>
            </div>
          </div>
          <div id="dataTableContainer"></div>
          <div id="pagination"></div>
        </div>`
      },
      loaderHtml: () => {
        return `
          <div class="loader">
            <div class="affiliate-dashboard-spinner">
              <div class="affiliate-dashboard-loader">
                <div>
                </div>
                <div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>`
      },
      loadLibraries: async () => {
        const scriptsToLoad = ['//netdna.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js', window.SFShopifyApp.shop_domain + 'apps/SFshop/assets/moment-with-locales.min.js', 'https://www.gstatic.com/charts/loader.js', window.SFShopifyApp.shop_domain + 'apps/SFshop/assets/qrcode.js', window.SFShopifyApp.shop_domain + 'apps/SFshop/assets/bootstrap-datetimepicker.min.js']
        for (let i = 0; i < scriptsToLoad.length; i++) {
          const script = scriptsToLoad[i]
          if (document.querySelectorAll(`script[src="${script}"]`).length == 0) {
            await new Promise((res, req) => {
              const siteHead = document.getElementsByTagName('head')[0]
              const scriptTag = document.createElement('script')
              scriptTag.src = script
              scriptTag.defer = 'true'
              scriptTag.type = 'text/javascript'
              scriptTag.onload = function () {
                res(true)
              }
              siteHead.appendChild(scriptTag)
            })
          }
        }
      },
      loadCss: () => {
        const stylesToLoad = ['//netdna.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css', window.SFShopifyApp.shop_domain + 'apps/SFshop/assets/bootstrap-datepicker.min.css', window.SFShopifyApp.shop_domain + 'apps/SFshop/assets/affiliate_dashboard.css']
        stylesToLoad.forEach((link) => {
          if (document.querySelectorAll(`link[href="${link}"]`).length == 0) {
            const siteHead = document.getElementsByTagName('head')[0]
            const styleTag = document.createElement('link')
            styleTag.setAttribute('rel', 'stylesheet')
            styleTag.setAttribute('type', 'text/css')
            styleTag.setAttribute('href', link)
            // eslint-disable-next-line no-undef
            siteHead.appendChild(styleTag)
          }
        })
      },
      loadDashboardAssets: () => {
        // eslint-disable-next-line no-undef
        const siteHead = document.getElementsByTagName('head')[0]

        const affiliate_dashboard_css_link = window.SFShopifyApp.shop_domain + 'apps/SFshop/assets/affiliate_dashboard.css'
        if (document.querySelectorAll(`link[href="${affiliate_dashboard_css_link}"]`).length == 0) {
          const styleTag = document.createElement('link')
          styleTag.href = affiliate_dashboard_css_link
          siteHead.appendChild(styleTag)
        }

        const affiliate_dashboard_js_link = window.SFShopifyApp.shop_domain + 'apps/SFshop/assets/affiliate_dashboard.js'
        if (document.querySelectorAll(`script[src="${affiliate_dashboard_js_link}"]`).length == 0) {
          const scriptTag = document.createElement('script')
          scriptTag.onload = function () {}
          scriptTag.src = affiliate_dashboard_js_link
          siteHead.appendChild(scriptTag)
        }
        document.addEventListener('DOMContentLoaded', function (event) {
          AffiliateDashboard.onLoad()
        })
      },
    }
    const Root = {
      onload: () => {
        Dashboard.onload()
      },
    }

    Root.onload()
  })
}

// eslint-disable-next-line no-undef
if (window.jQuery) {
  // jQuery is loaded
  loadApp()
} else {
  // eslint-disable-next-line no-undef
  let script = document.createElement('script')
  script.onload = function () {
    loadApp()
  }
  script.src = 'https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js'
  // eslint-disable-next-line no-undef
  document.getElementsByTagName('head')[0].appendChild(script)
}
